<div id="overlay">
  <div class="overlay-text">
    <mat-spinner></mat-spinner>
    <h1>Calculating...</h1>
  </div>
</div>

<div class="optimization-page">
  <!-- Page header -->
  <div class="page-head">
    <div class="page-head-main">
      <h1 class="page-title">
        @if (portfolio?.name) {
          <span class="pf-title-name">{{ portfolio.name }}</span>
        }
        @if (portfolio?.name) {
          <span class="pf-title-sep">·</span>
        }
        Optimization
        @if (optimName) {
          <span class="pf-title-sep">·</span>
        }
        @if (optimName) {
          <span>{{ optimName }}</span>
        }
      </h1>
    </div>
    <div class="d-flex align-items-end" style="gap: 8px">
      <button
        class="btn btn-ghost no-print"
        type="button"
        (click)="onExportPdf()"
        [disabled]="!portfolio || !dataLoaded()"
      >
        Export
      </button>
    </div>
  </div>

  <!-- Settings -->
  <div class="card no-print mb-3">
    <div class="card-body">
<!--       <div class="card-head">
        <div class="card-title">
          Settings<app-info infoIndex="11"></app-info>
        </div>
      </div> -->
      @if (dataLoaded()) {
        <div class="settings-controls">
          <div class="settings-field-wrap">
            <app-cim-datepicker
              [isFullWidth]="true"
              label="Start Date"
              [minDate]="portfolio.start_date"
              [model]="optimizationData.optim_parameters.return_start_date"
              (modelChanged)="
                optimizationData.optim_parameters.return_start_date = $event
              "
            ></app-cim-datepicker>
          </div>
          <div class="settings-field-wrap">
            <app-cim-datepicker
              [isFullWidth]="true"
              label="End Date"
              [minDate]="portfolio.start_date"
              [model]="optimizationData.optim_parameters.return_end_date"
              (modelChanged)="
                optimizationData.optim_parameters.return_end_date = $event
              "
            ></app-cim-datepicker>
          </div>
          <div class="settings-rfr-wrap">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Risk Free Rate</mat-label>
              <input
                matInput
                [(ngModel)]="portfolio.risk_free_rate"
                type="number"
                step="0.01"
              />
              <span matSuffix>%</span>
            </mat-form-field>
          </div>
          <div class="settings-quick-btns">
            <button
              mat-flat-button
              color="primary"
              (click)="triggerCalc('ytd')"
            >
              <span class="navigation-button">YTD</span>
            </button>
            <button mat-flat-button color="primary" (click)="triggerCalc('1')">
              <span class="navigation-button">1 Yr</span>
            </button>
            <button mat-flat-button color="primary" (click)="triggerCalc('5')">
              <span class="navigation-button">5 Yr</span>
            </button>
            <button mat-flat-button color="primary" (click)="triggerCalc('10')">
              <span class="navigation-button">10 Yr</span>
            </button>
            <button mat-flat-button color="primary" (click)="triggerCalc('15')">
              <span class="navigation-button">15 Yr</span>
            </button>
            <button
              mat-flat-button
              color="primary"
              (click)="triggerCalc('start')"
            >
              <span class="navigation-button">MAX</span>
            </button>
          </div>
          <button
            class="settings-optimize-btn has-inline-spinner"
            mat-flat-button
            color="primary"
            [disabled]="optimizing()"
            (click)="saveInputsAndTriggerHistoricalCalc()"
          >
            @if (optimizing()) {
              <mat-spinner diameter="18"></mat-spinner>
            }
            <span class="navigation-button">{{ optimizing() ? 'Optimizing…' : 'Optimize' }}</span>
          </button>
        </div>
      }
    </div>
  </div>

  <!-- Covariance / Correlation -->
  <div
    id="covariance-correlation-chart"
    #covarianceCorrelationChart
    class="card no-print mb-3"
  >
    <div class="card-body">
      <div class="card-head">
        <div class="card-title">
          Covariance / Correlation <app-info infoIndex="12"></app-info>
        </div>
      </div>
      @if (optimizationData && filterLists) {
        <app-optimization-sections
          [portfolio]="portfolio"
          [optimData]="optimizationData"
          [correlationMatrixData]="correlationMatrixData"
          [covarianceMatrixData]="covarianceMatrixData"
          [correlationMatrixTableData]="correlationMatrixTableData"
          [covarianceMatrixTableData]="covarianceMatrixTableData"
          [filterLists]="filterLists"
        ></app-optimization-sections>
      }
    </div>
  </div>

  <!-- Implied Views -->
  <div
    id="implied-views-section-optimized"
    #impliedViewsChart
    class="card no-print mb-3"
  >
    <div class="card-body">
      <div class="card-head">
        <div class="card-title">
          Implied Views <app-info infoIndex="13"></app-info>
        </div>
      </div>
      <div class="underscore">Top 3 largest holdings</div>
      <ul>
        @for (company of top3Holdings | slice: 0 : 3; track company.company_name) {
          <li>
            {{ company.company_name }} ({{
              (company.Weight * 100).toFixed(2)
            }}%): You are expecting {{ company.company_name }} to return
            {{ (company.implied_returns * 100).toFixed(2) }}%. (Mkt. Eq.
            {{ (company.market_equilibrium * 100).toFixed(2) }}%).
          </li>
        }
      </ul>
      <div class="underscore">
        Top 3 largest deviation from Market Equilibrium Returns
      </div>
      <ul>
        @for (company of top3LargestDev | slice: 0 : 3; track company.company_name) {
          <li>
            {{ company.company_name }} ({{
              (+company.mkt_eq_returns * 100).toFixed(2)
            }}%): You expect {{ company.company_name }} to
            {{ company.mkt_eq_returns > 0 ? "outperform" : "underperform" }} the
            Market Equilibrium Returns by
            {{ (+company.mkt_eq_returns * 100).toFixed(2) }}%.
          </li>
        }
      </ul>
      @if (!forecastedReturnsTableData.length) {
        <app-chart-placeholder></app-chart-placeholder>
      }
      @if (viewTablesLoaded() && forecastedReturnsTableData.length) {
        <app-cim-datatable
          [columns]="forecastedReturnsTableColumns"
          [data]="filteredForecastedReturnsTableData"
          [footer]="footerData"
          (inputChange)="onForecastedReturnInputChange()"
        ></app-cim-datatable>
      }
    </div>
  </div>

  <!-- Views -->
  <div id="my-views-section-optimized" #myViewsChart class="card no-print mb-3">
    <div class="card-body">
      <div class="card-head">
        <div class="card-title">Views <app-info infoIndex="14"></app-info></div>
      </div>
      @if (portfolio && optimizationData) {
        <app-optimization-views-panel
          [portfolio]="portfolio"
          [optimizationData]="optimizationData"
          [constraintLists]="constraintLists"
          [optimizing]="optimizing()"
          (optimize)="saveInputsAndTriggerHistoricalCalc()"
          (frequencyChanged)="
            optimizationData.optim_parameters.correlation_frequency = $event
          "
        ></app-optimization-views-panel>
      }
    </div>
  </div>

  <!-- Combined Returns -->
  <div
    id="combined-returns-section-optimized"
    #combinedReturnsChart
    class="card no-print mb-3"
  >
    <div class="card-body">
      <div class="card-head">
        <div class="card-title">
          Combined Returns <app-info infoIndex="15"></app-info>
        </div>
      </div>
      @if (viewTablesLoaded()) {
        <app-cim-datatable
          [columns]="historicalReturnTableColumns"
          [data]="filteredHistoricalReturnTableData"
          [sortProp]="'Weight'"
          sortDirection="desc"
        ></app-cim-datatable>
      }
    </div>
  </div>

  <!-- Constraints + Cost of constraints -->
  <div
    id="constraints-section-optimized"
    #constraintsChart
    class="card no-print mb-3"
  >
    <div class="card-body">
      @if (optimizationData) {
        <app-constraint-setter
          [portfolio]="portfolio"
          [constraints]="optimizationData.group_constraints"
          [sectors]="constraintLists.sectors"
          [assets]="constraintLists.assets"
          [countries]="constraintLists.countries"
          [optimizing]="optimizing()"
          (optimize)="saveInputsAndTriggerHistoricalCalc()"
        ></app-constraint-setter>
      }

      <div class="card-head mt-3">
        <div class="card-title">
          Cost of constraints<app-info infoIndex="17"></app-info>
        </div>
      </div>
      <table class="table m-0">
        <thead>
          <tr>
            <td class="text">Portfolio</td>
            <td class="text-end header-percent">Expected Return</td>
            <td class="text-end header-percent">Expected Volatility</td>
            <td class="text-end">Sharpe Ratio</td>
          </tr>
        </thead>
        <tbody>
          @for (item of optimPerformance["optim_performance"]; track $index) {
            <tr>
              <td class="text">Constrained</td>
              <td class="number-col text-end">
                {{ item.Expected_Return * 100 | number: "1.2-2" }}%
              </td>
              <td class="number-col text-end">
                {{ item.Std_Deviation * 100 | number: "1.2-2" }}%
              </td>
              <td class="number-col text-end">
                {{ item.Sharpe_Ratio | number: "1.2-2" }}
              </td>
            </tr>
          }
          @for (
            item of optimPerformance["optim_performance_unconstrained"];
            track item
          ) {
            <tr>
              <td class="text">Unconstrained</td>
              <td class="number-col text-end">
                {{ item.Expected_Return * 100 | number: "1.2-2" }}%
              </td>
              <td class="number-col text-end">
                {{ item.Std_Deviation * 100 | number: "1.2-2" }}%
              </td>
              <td class="number-col text-end">
                {{ item.Sharpe_Ratio | number: "1.2-2" }}
              </td>
            </tr>
          }
          @for (
            item of optimPerformance["optim_performance_cost_of_constrained"];
            track item
          ) {
            <tr>
              <td class="text">Cost of constraints</td>
              <td
                class="number-col text-end"
                [ngClass]="{
                  'text-red': item.Expected_Return < 0,
                  'text-green': item.Expected_Return > 0,
                  'text-blue': item.Expected_Return == 0,
                }"
              >
                {{ item.Expected_Return * 100 | number: "1.2-2" }}%
              </td>
              <td
                class="number-col text-end"
                [ngClass]="{
                  'text-red': item.Std_Deviation < 0,
                  'text-green': item.Std_Deviation > 0,
                  'text-blue': item.Std_Deviation == 0,
                }"
              >
                {{ item.Std_Deviation * 100 | number: "1.2-2" }}%
              </td>
              <td
                class="number-col text-end"
                [ngClass]="{
                  'text-red': item.Sharpe_Ratio < 0,
                  'text-green': item.Sharpe_Ratio > 0.1,
                  'text-blue': item.Sharpe_Ratio > 0,
                }"
              >
                {{ item.Sharpe_Ratio | number: "1.2-2" }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Results / Efficient Frontier -->
  <section id="results-section-optimized">
    @if (!(dataLoaded() && efficientChartLoaded())) {
      <app-chart-placeholder></app-chart-placeholder>
    }
    @if (dataLoaded() && efficientChartLoaded()) {
      <app-efficient-frontier-chart
        [series]="efficientSeries"
        [optimWeights]="efficientOptimWeights"
        [optim]="optim"
        [optimizationData]="optimizationData"
        [efficientChartMaxSharpeData]="efficientChartMaxSharpeData"
        [resultsTableData]="resultsTableData"
        (calculateClicked)="handleCalculate($event)"
        (optimizationDataChange)="onOptimizationDataRefreshed($event)"
        [volatilityLine]="volatilityLine"
        [minVolatility]="minVolatility"
        [maxVolatility]="maxVolatility"
      ></app-efficient-frontier-chart>
    }
  </section>
</div>
